import { listToTree } from './listToTree'

export const ramos = state => {
  let ramos = [
    {
      text: 'Todos',
      value: 0
    }
  ];
  ramos = ramos.concat(
    state.ramos.map(item => ({
      text: item.ramo,
      value: item.cod_ramo
    }))
  );
  return ramos;
};

export const productores = state => {

  let fullname = state.auth.nombre ? state.auth.nombre : ''
  let fulllastname = state.auth.apellido ? state.auth.apellido : ''
  let productores = [{
    text: fullname + ' ' + fulllastname + ' - ' + state.auth.cod_agente,
    value: state.auth.cod_agente,
    cod_tipo_agente: state.auth.cod_tipo_agente
  }]
  productores = productores.concat(state.productores.map(item => ({
    text: item.nombre + ' - ' + item.cod_agente,
    value: item.cod_agente,
    cod_tipo_agente: item.cod_tipo_agente
  })))
  return productores;
};

export const productoresComisionesRetenciones = state => {

  let productores = []
  productores = productores.concat(state.productoresComisionesRetenciones.map(item => ({
    text: item.nombre + ' - ' + item.cod_agente,
    value: item.cod_agente,
    cod_tipo_agente: item.cod_tipo_agente
  })))
  return productores;
};

export const productoresCartera = state => {
  let productores = []
  //console.log(state.productores);
  productores = productores.concat(state.productores.map(item => ({
    text: item.nombre + ' - ' + item.cod_agente,
    value: item.cod_agente,
    cod_tipo_agente: item.cod_tipo_agente,
    fav: item.fav
  })))
  return productores;
};

export const organizadoresCartera = state => {
  let organizadores = []
  organizadores = organizadores.concat(state.organizadores.map(item => ({
    text: item.nombre + ' - ' + item.cod_agente,
    value: item.cod_agente,
    cod_tipo_agente: item.cod_tipo_agente,
    fav: item.fav
  })))
  return organizadores;
};

export const tiposDeEndosoCartera = state => {
  let tiposDeEndoso = []
  //console.log(state);
  tiposDeEndoso = tiposDeEndoso.concat(state.tiposDeEndoso.map(item => ({
    text: item.grupo_desc,
    value: item.tiposDeEndoso,    
  })))
  return tiposDeEndoso;
};

export const NOMBRE_PRODUCTOR = state => {
  let firstName = state.auth.nombre || ''
  let lastName = state.auth.apellido || ''
  return firstName + ' ' + lastName;
};

export const EMAIL_PRODUCTOR = state => {
  return state.auth.email;
};

export const monedas = state => {
  return state.monedas;
};

export const tiposCuenta = state => {
  return state.tiposCuenta;
};


export const categoriasRecursos = state => {
  return listToTree(state.recursos.categorias)
}

export const postsRecursos = state => {
  return state.recursos.posts
}

export const getMenuProductor = state => {
  return state.menuProductor;
}
